<div *ngIf="searchData" role="main" class="container">
    <div class="top-section" *ngIf="!noResults?.fastNoResult;" >
        <div class="search-header">
            <finder-title class="search-title" [title]="searchData.title"></finder-title>
        </div>
        <div class="search-results-count">
            <div aria-live="polite">
                <span class="text">{{searchData.totalResultsFoundLabel | decodeURI}}</span>
            </div>
        </div>
    </div>
    <hr aria-hidden="true" class="rule"/>
    <div class="search show-groups">
        <finder-infinite-scrolling
            class="search-scroll-container search-scrollbar"
            (scrolled)="onScroll()"
            [isScrollable]="!isSearchCompleted" *ngIf="results?.length">
            <div class="group" *ngFor="let searchResult of results; let position = index; last as isLast">
                <finder-search-card
                    class="card"
                    (searchSelection)="onSearchSelection($event)"
                    [searchResult]="searchResult"
                    [searchTerm]="searchTerm"
                    [schedulesLabels]="searchSchedulesLabels"
                    [searchPosition]="position"
                >
                </finder-search-card>
                <hr aria-hidden="true" class="rule" *ngIf="!isLast" />
            </div>
            <finder-loading-spinner class="search-loading-spinner" *ngIf="isLoading"></finder-loading-spinner>
        </finder-infinite-scrolling>
        <finder-no-results *ngIf="!results?.length"
            [searchNoResults]="noResults"
            [searchTerm]="searchTerm">
        </finder-no-results>
    </div>
</div>
